// @flow

import React, { useState } from 'react'
import glamorous from 'glamorous'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import { Subscribe } from 'unstated'
import {
  HeadingText,
  TextInput,
  TextArea,
  Combobox,
  Dialog,
} from '@paypalcorp/pp-react'

// unstated
import SellerProfileState from '../state'

// content
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/details')

import HandleInput from './input-container'

const GenericInputContainerPadding = glamorous.div({
  margin: '26px 0',
})

const ButtonContainer = glamorous.div({
  display: 'flex',
})

const ContinueButton = glamorous.button({
  margin: 'auto',
  width: '65%',
})

const DialogHeading = glamorous.h3({
  textAlign: 'center',
})

const DialogParagraphContainer = glamorous.div({
  textAlign: 'center',
  marginBottom: '3rem',
})

function OnBoardingDetails(props) {
  const { merchantCategoryCodesList = [] } = props
  const { updateBusinessDetails } = props.sellerProfileState
  const { isValidBusinessHandle } = props.sellerProfileState.state

  // build the correct structure for category combobox
  const categoryOptions = merchantCategoryCodesList.map(item => {
    item.query.push(item.mccTitle)
    const terms = _.uniq(item.query)
    return {
      label: item.mccTitle,
      value: item.mcc,
      id: `item-${item.mcc}`,
      _queryable: terms, // add mccTitle here! so we can just pull query and be done
    }
  })

  const [showDialog, setShowDialog] = useState(false)

  const [inputs, setInputs] = useState({
    businessName: '',
    businessHandle: '',
    businessDescription: '',
    businessCategory: '',
  })

  const handleChangeInput = e => {
    const updates = {
      ...inputs,
      [e.target.name]: e.target.value,
    }
    setInputs(updates)
    updateBusinessDetails(updates)
  }

  const revealNextCTA = () => {
    return (
      inputs.businessName !== '' &&
      inputs.businessHandle !== '' &&
      inputs.businessCategory !== '' &&
      inputs.businessDescription !== '' &&
      isValidBusinessHandle &&
      !errorTextArea
    )
  }

  // text area stuff
  const [value, setValue] = useState('')
  const [isErrorTextArea, setErrorTextArea] = useState(false)
  const maxCharacters = 200
  const handleTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    handleChangeInput(e)
    setValue(e.target.value)
    setErrorTextArea(e.target.value.length > maxCharacters)
  }
  const errorTextArea = isErrorTextArea && l10n('main.textArea.error')

  return (
    <>
      <Dialog
        onClose={() => {
          setShowDialog(!showDialog)
        }}
        isOpen={showDialog}
        closeOnBackgroundClick
      >
        <DialogHeading>{l10n('dialog.heading')}</DialogHeading>
        <DialogParagraphContainer>
          <p>{l10n('dialog.paragraph1')}</p>
          <p>{l10n('dialog.paragraph2')}</p>
        </DialogParagraphContainer>
      </Dialog>

      <HeadingText size="md" role="heading" aria-level="1">
        {l10n('main.heading')}
      </HeadingText>
      <br />
      <button
        type="button"
        className="vx_btn-link"
        onClick={() => {
          setShowDialog(!showDialog)
        }}
      >
        {l10n('main.learnMore')}
      </button>
      <GenericInputContainerPadding>
        <TextInput
          name="businessName"
          label={l10n('main.businessNameInput.label')}
          value={inputs.businessName}
          onChange={handleChangeInput}
          autoComplete="off"
        />
      </GenericInputContainerPadding>
      <GenericInputContainerPadding>
        <HandleInput
          sellerProfileState={props.sellerProfileState} // use the props.sellerProfileSettings.state.businessHandle !!! ???
          inputValue={inputs.businessHandle}
          selectedValue={inputs.businessHandle} // ??? why???
          updateBusinessHandle={handleChangeInput}
        />
      </GenericInputContainerPadding>
      <GenericInputContainerPadding>
        <TextArea
          name="businessDescription"
          value={value}
          label={l10n('main.textArea.label')}
          onChange={handleTextAreaChange}
          showCharacterCounter
          maxCharacters={maxCharacters}
          errorText={errorTextArea}
          autoComplete="off"
        />
      </GenericInputContainerPadding>
      <GenericInputContainerPadding>
        <Combobox
          options={categoryOptions}
          name="businessCategory"
          label={l10n('main.category.label')}
          onChange={handleChangeInput}
        />
      </GenericInputContainerPadding>
      {revealNextCTA() && (
        <ButtonContainer>
          <ContinueButton className="vx_btn" label="Next">
            {l10n('main.continue')}
          </ContinueButton>
        </ButtonContainer>
      )}
    </>
  )
}

// export default OnBoarding
const RouterOnBoarding = withRouter(OnBoardingDetails)
const SubscribedOnBoarding = (props: {}) => (
  <Subscribe to={[SellerProfileState]}>
    {sellerProfileState => (
      <RouterOnBoarding {...props} sellerProfileState={sellerProfileState} />
    )}
  </Subscribe>
)
export default SubscribedOnBoarding
